export default "__VITE_ASSET__Cl8YD8p4__"